<script>
  import FormularioContato from '../../domains/pessoal/components/Contato'

  import * as authService from '../../services/authService'

  import bus from '@utils/bus'
  import {mapGetters, mapActions} from 'vuex'
  import * as restfulService from '../../services/restfulService'
  import swal from 'sweetalert2'
  import baseConfig from '../../../config'

  export default {
    components: {FormularioContato},
    name: 'app-sidebar',
    data () {
      return {
        mostrarBibliotecas: false,
        mostrarModalContato: false,
        menuAtivo: '',
        versaoAtual: null
      }
    },
    computed: {
      ...mapGetters(['showSidebar', 'currentUser']),
      professor: function () {
        return this.currentUser.pessoa ? (this.currentUser.pessoa.perfil_professor || false) : false
      },
      soEnsinoBasico: function () {
        return this.currentUser.so_ensino_basico || false
      }
    },
    watch: {
      '$route': function (val) {
        if (val.name) {
          this.menuAtivo = val.name
        }
      }
    },
    async mounted () {
      this.buscarRotaAtual()
      this.versaoAtual = baseConfig.appVersion
    },
    methods: {
      ...mapActions(['logout']),
      buscarRotaAtual () {
        if (this.$route.name) {
          this.menuAtivo = this.$route.name
        }
      },
      onLogout () {
        bus.$emit('show-loader')
        authService.logout()
          .then(() => {
            this.$router.push({name: 'login'})
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      toggleBibliotecas () {
        this.mostrarBibliotecas = !this.mostrarBibliotecas
      },
      abrirBiblioteca (biblioteca) {
        let url = baseConfig.fullAPIPath
        let refPessoa = this.currentUser.ref_pessoa
        if (biblioteca !== 'bminhabiblioteca') {
          window.open(url + `biblioteca/${biblioteca}/login/${refPessoa}`, '_blank')
        } else {
          bus.$emit('show-loader', {message: 'Carregando biblioteca, aguarde...'})
          let action = `${biblioteca}/login/${refPessoa}`
          restfulService.get('biblioteca', action)
            .then(response => {
              bus.$emit('hide-loader')
              if (response.url) {
                window.open(response.url, '_blank')
              } else {
                swal({
                  title: 'Atenção',
                  html: 'Acesso Indisponível no Momento, entre em contato com a Central de Atendimento para mais detalhes.',
                  type: 'warning'
                })
              }
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
        }
      },
      exibeProtocolo () {
        /*
         * Exibe protocolo somente para graduação com contrato ativo
         * let user = this.currentUser
         * Chamado 379 - Todos q tem acesso ao sou podem abrir protocolos por enquanto
         * return (user.tipos_contratos.find(tipoContrato => tipoContrato.id === 1))
         */
        return true
      }
    }
  }

</script>

<template>
    <aside class="sidebar"
           v-bind:class="{ '-hidden': !showSidebar }">
        <nav class="sidebar-menu">
            <span class="header">Acadêmico</span>
            <a v-if="professor" href="https://webdiario.urcamp.edu.br" target="_blank">
                <span class="sidebar-icon">
                    <i class="fas fa-chalkboard-teacher"></i>
                </span>
                <span class="text">Webdiário</span>
            </a>
            <router-link :to="{name: 'academico.grade-horarios'}"
                         v-bind:class="{'-active': menuAtivo === 'academico.grade-horarios'}">
                <span class="sidebar-icon">
                    <i class="far fa-calendar-alt"></i>
                </span>
                <span class="text">Grade de Horários</span>
            </router-link>
            <router-link :to="{name: 'academico.frequencia-notas'}"
                         v-bind:class="{'-active': menuAtivo === 'academico.frequencia-notas'}"
            v-if="!soEnsinoBasico">
                <span class="sidebar-icon">
                    <i class="fab fa-firstdraft"></i>
                </span>
                <span class="text">Frequência e Notas</span>
            </router-link>
            <router-link :to="{name: 'academico.boletins-pareceres'}"
                         v-bind:class="{'-active': menuAtivo === 'academico.boletins-pareceres'}">
                <span class="sidebar-icon">
                    <i class="fas fa-edit"></i>
                </span>
                <span class="text">Boletins e Pareceres</span>
            </router-link>
            <router-link :to="{name: 'academico.atestado-matricula'}"
                         data-intro="Gerar o seu atestado de matrícula do curso"
                         data-step="3"
                         v-bind:class="{'-active': menuAtivo === 'academico.atestado-matricula'}">
                <span class="sidebar-icon">
                    <i class="fas fa-file-pdf"></i>
                </span>
                <span class="text">Atestado de Matrícula</span>
            </router-link>
            <router-link :to="{name: 'academico.atestado-trancamento'}"
                         data-intro="Gerar o seu atestado de vínculo com trancamento"
                         data-step="3"
                         v-bind:class="{'-active': menuAtivo === 'academico.atestado-trancamento'}">
                <span class="sidebar-icon">
                    <i class="fas fa-file-pdf"></i>
                </span>
                <span class="text">Atestado de Trancamento</span>
            </router-link>
            <router-link :to="{name: 'academico.disciplinas-cursadas'}"
                         v-bind:class="{'-active': menuAtivo === 'academico.disciplinas-cursadas'}"
                         v-if="!soEnsinoBasico">
                <span class="sidebar-icon">
                    <i class="far fa-file-alt"></i>
                </span>
                <span class="text">Disciplinas Cursadas</span>
            </router-link>
            <span class="header">Financeiro</span>
            <router-link :to="{name: 'financeiro.minhas-cobrancas'}"
                         data-intro="Suas cobranças e boletos junto a URCAMP"
                         data-step="4"
                         v-bind:class="{'-active': menuAtivo === 'financeiro.minhas-cobrancas'}">
                <span class="sidebar-icon">
                    <i class="fas fa-barcode"></i>
                </span>
                <span class="text">Minhas Cobranças</span>
            </router-link>
            <router-link :to="{name: 'financeiro.demonstrativo'}"
                         v-bind:class="{'-active': menuAtivo === 'financeiro.demonstrativo'}">
                <span class="sidebar-icon">
                    <i class="fas fa-file-alt"></i>
                </span>
                <span class="text">Demonstrativo Anual</span>
            </router-link>
            <span class="header">Serviços</span>
            <router-link v-if="exibeProtocolo()" :to="{name: 'protocolo'}"
                         v-bind:class="{'-active': menuAtivo === 'protocolo'}">
                <span class="sidebar-icon">
                    <i class="fas fa-tasks"></i>
                </span>
                <span class="text">Protocolos</span>
            </router-link>
            <a href="http://biblioteca.urcamp.edu.br/Biblivre4/" target="_blank">
                <span class="sidebar-icon">
                    <i class="fas fa-book"></i>
                </span>
                <span class="text">Biblioteca</span>
            </a>
            <a href="#" @click="toggleBibliotecas" v-if="!soEnsinoBasico">
                <span class="sidebar-icon">
                    <i class="fas fa-globe"></i>
                </span>
                <span class="text">Bibliotecas Virtuais</span>
                <span class="sidebar-icon icon-right">
                    <i class="fas fa-chevron-down"></i>
                </span>
            </a>
            <div class="bibliotecas" v-bind:class="{'-mostrar': mostrarBibliotecas}" v-if="!soEnsinoBasico">
                <a href="#" @click.prevent.stop="abrirBiblioteca('bminhabiblioteca')">Minha Biblioteca</a>
            </div>
            <a href="https://ouvidoria.urcamp.edu.br/"
               target="_blank">
                <span class="sidebar-icon">
                    <i class="fas fa-phone-square"></i>
                </span>
                <span class="text">Ouvidoria</span>
            </a>
            <a href="https://inscricoes.eventos.urcamp.edu.br"
               target="_blank">
                <span class="sidebar-icon">
                    <i class="fab fa-connectdevelop"></i>
                </span>
                <span class="text">Inscrição/Submissão de trabalhos</span>
            </a>

            <a href="https://eventos.urcamp.edu.br"
               target="_blank">
                <span class="sidebar-icon">
                    <i class="fab fa-connectdevelop"></i>
                </span>
                <span class="text">Sistema de Eventos</span>
            </a>

            <span class="header">Pessoal</span>
            <router-link :to="{name: 'minha-conta.inicial'}"
                         data-intro="Edite seus dados pessoais, avatar, email acadêmico, permissões de notificação..."
                         data-step="5"
                         v-bind:class="{'-active': menuAtivo === 'minha-conta.inicial'}">
                <span class="sidebar-icon">
                    <i class="far fa-user-circle"></i>
                </span>
                <span class="text">Minha Conta</span>
            </router-link>
            <router-link v-if="false" :to="{name: 'meu-drive'}" v-bind:class="{'-active': menuAtivo === 'meu-drive'}">
                <span class="sidebar-icon">
                    <i class="fab fa-google-drive"></i>
                </span>
                <span class="text">Meu Drive</span>
            </router-link>
            <a v-if="false"
               href="https://accounts.google.com/signin/v2/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F&amp;service=mail&amp;hd=urcamp.edu.br&amp;sacu=1&amp;flowName=GlifWebSignIn&amp;flowEntry=AddSession&amp;hl=pt"
               target="_blank">
                <span class="sidebar-icon">
                    <i class="far fa-envelope"></i>
                </span>
                <span class="text">Meu Email do Google</span>
            </a>
            <a href="#" @click="mostrarModalContato = true">
                <span class="sidebar-icon">
                    <i class="fas fa-question-circle"></i>
                </span>
                <span class="text">Fale Conosco</span>
            </a>
            <a href="#" @click="onLogout">
                <span class="sidebar-icon">
                    <i class="fas fa-sign-out-alt"></i>
                </span>
                <span class="text">Sair</span>
            </a>
        </nav>
        <formulario-contato :mostrar.sync="mostrarModalContato"/>
        <div class="app-version" v-if="versaoAtual">
          Versão {{ versaoAtual }}
        </div>
    </aside>
</template>

<style lang="scss">
    .app-version {
      text-align: center;
      font-size: 10px;
      line-height: 1.1;
      padding: 10px 0;
      font-weight: 700;
      color: #4d4d4d;
    }

    .sidebar {
        width: 200px;
        min-height: 100vh;
        height: 100%;
        background-color: #FFFFFF;
        -webkit-box-shadow: 1px 0 1px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 1px 0 1px 0 rgba(0, 0, 0, 0.1);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 90;
        transition: all .3s ease-in-out;

        > .sidebar-menu {
            padding-top: 80px;

            > span,
            > a {
                display: block;
                padding: 0 8px;

                &.header {
                    background-color: #f2f2f2;
                    line-height: 24px;
                    font-size: 10px;
                    text-transform: uppercase;
                    margin-top: 15px;
                    font-weight: 700;
                    color: #4d4d4d;
                }
            }
            > a {
                line-height: 36px;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                text-decoration: none;
                -webkit-transition: all .2s ease-out;
                transition: all .2s ease-out;

                .sidebar-icon {
                    width: 26px;
                    text-align: center;

                    &.icon-right {
                        font-size: 12px;
                    }
                }
                span.text {
                    color: #7a7a7a;
                    font-size: 14px;
                    letter-spacing: -0.02em;
                }
                svg path {
                    fill: #E0933F;
                }

                &.-active,
                &:hover,
                &:active,
                &:focus {
                    background-color: #2F423A;
                    span {
                        color: #FFF;
                    }
                }
            }

            .bibliotecas {
                display: none;
                background-color: #ebebeb;
                &.-mostrar {
                    display: block;
                }
                a {
                    display: block;
                    text-decoration: none;
                    line-height: 18px;
                    padding: 6px 30px;
                    font-size: 12px;
                    border-bottom: 1px solid #d9d9d9;

                    &:hover,
                    &:active,
                    &:focus {
                        background-color: #f6f6f6;
                    }
                }
            }
        }
    }

    @media all and (max-width: 1024px) {
        .sidebar {
            position: fixed;
            left: 0;
            top: 0;
            overflow: auto;
            height: 100vh;
            > .sidebar-menu {
                padding-top: 80px;
            }

            &.-hidden {
                left: -230px;
            }
        }
    }

    @media all and (max-width: 768px) {
        .sidebar {
            > .sidebar-menu {
                padding-top: 55px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// Sidebar.vue?01164ad4